import React, { useState } from 'react';
import { Header, Titulo } from '../elementos/Header';
import { Helmet } from 'react-helmet';
import BtnRegresar from '../elementos/BtnRegresar';
import BarraTotalGastado from './BarraTotalGastado';
import useObtenerIngresos from '../hooks/useObtenerIngresos';
import {  
    Lista,
    ElementoLista,
    Descripcion,
    Categoria,
    Valor,
    Fecha,
    ContenedorBotones,
    BotonAccion,
    BotonCargarMas,
    ContenedorBotonCentral,
    ContenedorSubtitulo,
    Subtitulo 
} from '../elementos/ElementosDeLista';
import formatearCantidad from '../funciones/convertirAMoneda';
import IconoCategoria from './../elementos/IconoCategoria';
import { ReactComponent as IconoEditar } from './../imagenes/editar.svg';
import { ReactComponent as IconoBorrar } from './../imagenes/borrar.svg';
import { Link } from 'react-router-dom';
import Boton from './../elementos/Boton';
import { format, fromUnixTime } from 'date-fns';
import { es } from 'date-fns/locale';
import borrarIngreso from '../firebase/borrarIngreso';
import Alerta from './../elementos/Alerta';

const ListaDeIngresos = () => {
    
    // Conseguimos los gastos desde nuestro hook obtenerIngresos
    const [ingresos, obtenerMasIngresos, hayMasPorCargar] = useObtenerIngresos();

    // Creamos un nuevo estado para las alertas
    const [estadoAlerta, cambiarEstadoAlerta] = useState(false);

    // Creamos otro estado para el mensaje de alerta
    const [alerta, cambiarAlerta] = useState({});
    
    // Función para formatear fecha de Unix a fecha normal
    const formatearFecha = (fecha) => {
        return format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy", {locale: es});
    };

    // Comprobar fechas que son iguales
    const fechaEsIgual = (ingresos, index, ingreso) => {
        if (index !== 0) {
            const fechaActual = formatearFecha(ingreso.fecha);
            const fechaGastoAnterior = formatearFecha(ingresos[index - 1].fecha);

            if(fechaActual === fechaGastoAnterior) {
                return true;
            } else {
                return false;
            }
        }
    };

    return (  
        <>
            <Helmet>
                <title>Lista de ingresos</title>
            </Helmet>

            <Header>
                <BtnRegresar />
                <Titulo>Lista de ingresos</Titulo>
            </Header>

            <Lista>
                {ingresos.map((ingreso, index) => {
                    return (
                        <div key={ingreso.id}>
                            {!fechaEsIgual(ingresos, index, ingreso) &&
                                <Fecha>{formatearFecha(ingreso.fecha)}</Fecha>
                            }
                            
                            <ElementoLista key={ingreso.id}>
                                <Categoria>
                                    <IconoCategoria id='income'/>
                                    INGRESO
                                </Categoria>

                                <Descripcion>
                                    {ingreso.descripcion}
                                </Descripcion>

                                <Valor>
                                    {formatearCantidad(ingreso.cantidad)}
                                </Valor>

                                <ContenedorBotones>
                                    <BotonAccion as={Link} to={`/editar-ingreso/${ingreso.id}`}>
                                        <IconoEditar />
                                    </BotonAccion>
                                    <BotonAccion onClick={() => {
                                                borrarIngreso(ingreso.id)
                                                cambiarEstadoAlerta(true);
                                                cambiarAlerta({
                                                    tipo: 'exito',
                                                    mensaje: 'Ingreso eliminado correctamente'
                                                });
                                            }    
                                        }>
                                        <IconoBorrar />
                                    </BotonAccion>
                                </ContenedorBotones>
                            </ElementoLista>
                        </div>
                    );
                })}

                <ContenedorBotonCentral>
                    { 
                        hayMasPorCargar & ingresos.lenth >= 10 ?
                        <BotonCargarMas onClick={() => obtenerMasIngresos()}>Cargar más</BotonCargarMas>
                        :
                        ''
                    }
                </ContenedorBotonCentral>

                {ingresos.length === 0 &&
                    <ContenedorSubtitulo>
                        <Subtitulo>No hay ingresos por mostrar</Subtitulo>
                        <Boton as={Link} to="/ingresos" primario='not-ok'>Agregar Ingreso</Boton>
                    </ContenedorSubtitulo>
                }
            </Lista>

            <BarraTotalGastado/>
            <Alerta
                tipo = { alerta.tipo }
                mensaje = { alerta.mensaje }
                estadoAlerta = { estadoAlerta }
                cambiarEstadoAlerta = { cambiarEstadoAlerta }
            />
        </>
    );
}
 
export default ListaDeIngresos;